module.exports = __webpack_public_path__ + "img/GF.09072833.png";